module.exports = __webpack_public_path__ + "img/bg7.563dd057.png";